<template>
    <div>
		<el-card v-if="redeemUrl">
			兑换地址：<el-link :href="redeemUrl" target="_blank" class="MR10">{{redeemUrl}}</el-link>			
			<el-button type="primary" size="small" @click="copyLink">复制链接</el-button>
			<el-button type="primary" size="small" class="ML10" @click="$refs.CodeShow.show()">领取二维码</el-button>
			<input class="copyTool" ref="copyTool" :value="redeemUrl" />
		</el-card>
        <div class="page-filter-box MT20">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="优惠券ID" :value="1"></el-option>
                            <el-option label="兑换码" :value="2"></el-option>
							<el-option label="兑换手机号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.status" placeholder="请选择" size="small">
				        <el-option label="不限制兑换码状态" :value="-1"></el-option>
				        <el-option label="仅查看已兑换的" :value="1"></el-option>
				        <el-option label="仅查看未兑换的" :value="0"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.redeemStatus" placeholder="请选择" size="small">
				        <el-option label="不限制有效状态" :value="-1"></el-option>
				        <el-option label="仅查看有效的" :value="1"></el-option>
				        <el-option label="仅查看已作废的" :value="0"></el-option>
						<el-option label="仅查看已过期的" :value="2"></el-option>
				    </el-select>
				</el-col>                
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">					
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
		<div class="page-btns-box">
		    <el-button  type="primary"  size="small" @click="download()" icon="el-icon-download">导出明细</el-button>
			<el-button v-if="$utils.have('/coupon/redeem/invalidate_batch')" type="primary" icon="el-icon-delete"
				@click="BeachcancelCode()" size="small">批量作废</el-button>
		</div>
       <div class="page-list-box">
       	<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
       		@selection-change="handleSelectionChange">
       		<el-table-column type="selection"></el-table-column>
       		<el-table-column label="状态" min-width="140">
       			<template slot-scope="scope">
       				<p>兑换状态：{{scope.row.redeemStatus}}</p>
       				<p>有效状态：{{scope.row.status}}</p>
       			</template>
       		</el-table-column>
       		<el-table-column prop="ruleId" label="优惠券ID" min-width="120"></el-table-column>
       		<el-table-column prop="couponName" label="优惠券名称" min-width="120" show-overflow-tooltip></el-table-column>       		
       		<el-table-column prop="redeemCode" label="兑换码" min-width="140"> </el-table-column>
       		<el-table-column prop="tel" label="兑换手机号" min-width="120"></el-table-column>	
			<el-table-column prop="userName" label="兑换用户"></el-table-column>			
       		<el-table-column prop="createUserName" label="生成人"></el-table-column>
       		<el-table-column label="时间" min-width="220">
       			<template slot-scope="scope">
       				<p>生成时间：{{scope.row.createTime}}</p>
       				<p>兑换截止：{{scope.row.deadlineTime}}</p>
       				<p>兑换时间：{{scope.row.redeemTime}}</p>
       				<p>作废时间：{{scope.row.invalidateTime}}</p>
       			</template>
       		</el-table-column>       
       		<el-table-column fixed="right" label="操作" width="160">
       			<template slot-scope="{row} = scope">
       				<el-button v-if="$utils.have('/activity/redeemCodeCancel') && row.redeemStatus === '未兑换' && row.status !='已作废'" type="text"
       					size="small" icon="el-icon-document-delete" @click="delConfirm(row)">作废删除</el-button>
       			</template>
       		</el-table-column>
       	</el-table>
       </div>
       <div v-if="data" class="page-pagination-box">
       	<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
       		:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
       		layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
       	</el-pagination>
       </div>
        <code-show ref="CodeShow"></code-show>
		<DeleteConfirmRedem ref="deleteConfirm" @submitSuccess="getDataList"></DeleteConfirmRedem>
    </div>
</template>

<script>
import DeleteConfirmRedem from './components/DeleteConfirmRedem'
import {downloadFileTmp} from '@/assets/js/commonApi.js';
import CodeShow from "./components/code-show.vue";
export default {
    components:{CodeShow,DeleteConfirmRedem},
    data(){
        this.defaultParams = {
            searchType: 1,
            searchValue: null,
            status:-1,
            redeemStatus: -1,
            pageNo: 1,
            pageSize: this.$pageSizes[0]
        };

        return {
            data: [],
            dataList: [],
            params:{
                ...this.defaultParams,
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                status: parseInt(this.$route.query.status || -1),
                redeemStatus: parseInt(this.$route.query.redeemStatus || -1),
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            },
            listLoading: true,
			uploadLoading:false,
			redeemCodes: [],
			redeemUrl: `${process.env.VUE_APP_SSWAP_URL}/pages/coupon/redeem`,
			copyTimer: null,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
		//复制链接
		copyLink(){
		    clearTimeout(this.copyTimer);
		    this.copyTimer = setTimeout(() => {
		        const e = this.$refs.copyTool;
		        e.select();
		        document.execCommand("Copy"); // 执行浏览器复制命令
		        this.$message.success("已复制成功，可粘贴");
		    },300)
		},
        //获取列表
        async getDataList() {			
            this.listLoading = true;
            const res = await this.$request({
                url: '/coupon/redeem/list',
                method: 'post',
                data: {...this.params}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
        },
		//全选、反选
		handleSelectionChange(val) {
			this.redeemCodes = val.map(v => v.redeemCode);
		},
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...this.defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		//批量作废
		BeachcancelCode() {
			console.log(this.redeemCodes)
			let _redeemCodes = [],
				_msg = "";
			_redeemCodes = [...this.redeemCodes]
			if (_redeemCodes.length < 1) {
				return this.$message.error("请选择需要作废删除的兑换码");
			}
			_msg = "仅未兑换状态兑换码支持批量作废，时效原因，批量作废时部分兑换码若已兑换，系统会自动跳过";
			this.$confirm(_msg, '作废删除', {
				// type: 'warning',
				center: true,
				closeOnClickModal: false,
			}).then(() => {
				this.listLoading = true;
				this.$request({
					url: '/coupon/redeem/invalidate_batch',
					method: 'POST',					
					params: {redeemCodes: _redeemCodes.toString()}
				}).then(res => {
					const {
						state,
						msg
					} = res.data;
					if (state == 1) {
						let timer = setTimeout(() => {
							this.getDataList();
							clearTimeout(timer);
						}, 500)
		
					} else {
						this.$message.error(msg || '请求失败');
						this.listLoading = false;
					}
				}).catch(() => {
					this.$message.error('请求错误');
					this.listLoading = false;
				}).finally(() => {
					// this.listLoading = false;
				});
			})
		},
       
        // 删除确认
        async delConfirm(row) {
            const {id} = row;        
            const flag = await this.$confirm('确定要删除该兑换码吗?', '确认删除', {
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).catch(() => {
                return 'cancel';
            });
        
            if(flag === 'cancel') {
                return;
            }        
            // 验证优惠券是否存在已经被用户领取
            const res = await this.$request({
                url: '/coupon/validate',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });
        
            const { state, msg, result } = res.data;        
            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }            
            // 二次确认
            if(result.unUseCount > 0) {
                this.$refs.deleteConfirm.show(id);
                return ;
            }        
            // 删除请求
            this.del(row);
        },
        // 删除
        async del(row) {
            const res = await this.$request({
                url: '/coupon/redeem/invalidate',
                method: 'post',
                params: {redeemCode:row.redeemCode,redeemId:row.id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });
        
            const { state, msg } = res.data;
        
            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }
        
            this.getDataList();
        },
		async download() {
			let filePath, fileName;
			this.downLoading = true;
			const res = await this.$request({
					url: '/coupon/export/redeem',
					method: 'post',
					data: {
						...this.params
					},
				})
				.catch(err => {
					this.$message({
						message: err.message,
						type: 'error'
					});
				})
			const {
				state,
				msg,
				result
			} = res.data;
			if (state == 1 && result) {
				filePath = result.url;
				fileName = result.fileName;
			} else {
				this.downLoading = false;
				return this.$message.error(msg || '下载失败');
			}
		
			await downloadFileTmp(filePath, '兑换码明细.' + this.$utils.getFileType(filePath));
		
			this.downLoading = false;
		},
		
    }
}
</script>
<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>